require('gsap');
// require('gsap18/utils/SplitText.js');
// require('gsap18/plugins/DrawSVGPlugin');
// require('gsap18/plugins/MorphSVGPlugin');

var menuToggler = require('menu-toggler');
// require('menu-floating');
// require('lang-toggler');
// require('search-toggler');
// require('news-slide');
// require('home-slide');
// require('domaine-slide');
// require('presse-toggle');
// require('vins-hover');
// require('cyma-video');
require('jquery-easing');
require('scrollto');
require('wpcf');
// require('share');
require('init');
require('bg-black-observer');
// require('age-gate');
// require('addiction-header');
// require('addiction-header-svg');
// require('addiction-home-slide');
require('reveal-events');
// require('nda-chrono');
// require('nda-points');
// require('news-loader');
// require('docs-preview'); 
// require('people-popup'); 
require('slides.js');
// require('popupoutlinks.js');
// require('side-menu');
// require('home-incident-popup');
// require('home-video');
// require('drlocator'); 
// require('sticky-kit');
require('embedvideoframe');
// require('filter-grid');
// var filterGridHooksManager = require('filter-grid-hook-manager');
// require('./burger.js');
// require('lotties');
// require('./leaflet-filters.js');
// require('./smoke.js');

// var panzoom = require('panzoom');


require('es6-promise/auto');
require('./sksmooth-anims.js');
require('./sksmooth-funcs.js');
// require('france'); 

var form_file_input = require('form-file-input-wp');
require('form-select2-wp');

require('cymasmooth/config-defaut');
var NProgress = require('cymasmooth/ajax-load-progress');
// require('./anims/mask.js');

var cymasmooth = require('cymasmooth');
cymasmooth.registerFuncMulti( 'onRenderPage', require('cymasmooth/update-wp-lang-menu') );
cymasmooth.registerFunc( 'onShow', require('cymasmooth/onshow-loading-data-attr') );

// var cymasmoothcache = require('cymasmooth-cache-v2');

var imagesLoaded = require('imagesloadedwithsize');
var site = require('site');
// var paralax = require('paralax');
var reveal = require('reveal');
// require('fastclick');
// var scrollmenu = require('scrollmenu');
// var scrollmenu = require('kojy-explo-slide');
// require('./cursor-follow.js');
require('./cursor.js'); 
// require('./qw-logos.js'); 

 
var MQ = require('mq');

// require('./compo/mask.js');
require('wrapmask');

require('vh2');
// require('./homeslide.js');

// require('./codic-map.js');
// require('./testdb.js');

require('fancybox');
require('resizefull');
// require('mapzoom');
// require('wheel3');

var $ = require('jquery'); 

// var emresizer = require('emresizer');
// var siteloader = require('./site-loader.js'); 
// var siteloader = require('./site-loader-mr.js'); 
// var siteloader = require('./site-loader-serau.js');
// var siteloader = require('./site-loader-gf.js'); 
// var siteloader = require('./site-loader-addiction.js');
// var siteloader = require('./site-loader-leva.js');
// var siteloader = require('./site-loader-video.js');
var siteloader = require('./site-loader-eos.js');
// var siteloader = require('./site-loader-cultes.js');
// var siteloader = require('./site-loader-valpaco.js'); 
// var siteloader = require('./site-loader-pf.js');
// var siteloader = require('./site-loader-madeleine.js');
// var siteloader = require('./site-loader-campus.js');

// require('bg-black-observer');
// require('histoires-nav');

var resize_done = 0;
// var windowResizeHandler = function(){
// 	// if ( MQ(-767) && resize_done > 0 ) {
// 		// return;
// 	// }
// 	// phplog('emresize');
// 	// console.log('emresize');
// 	// console.log('homeintrowidth', $('.home__intro__content').width());
// 	// console.log('homeintrowidth', $('.home__intro__content').height());
// 	$('[data-js-emresize="1"]').each(function(i, el){
// 		var q = $(el).attr('data-js-emresize-measure');
// 		if ( !q ) {
// 			q = '.emresizer';
// 		}
// 		var w = $(q).width();
// 		var h = $(q).height();
// 		console.log('emresizer w', w);
// 		console.log('emresizer h', h);
// 		emresizer.resizeb( [el], true, w, h );
// 		// emresizer.resizeb( $('[data-js-emresize="1"]').get(), true );
// 	});
// 	resize_done++;
// };
// $(window).on("cube:resizereal", windowResizeHandler);
// $(window).on("resize", windowResizeHandler);
// // $(window).on("site:initPage", windowResizeHandler);
// $(window).on("vh:done", windowResizeHandler);
// windowResizeHandler();



$(window).trigger('resize');
siteloader(function(){	
	// $(window).on('load', function(){
	// alert('start')
	// cymasmooth.initCurrentPageSimple();
	// site.initPage( $('html') );
	// NProgress();
	// $(window).trigger('cymasmooth:onAjaxLoad');
	cymasmooth.initCurrentPage();
	setTimeout(function() {
		// cymasmoothcache.init();
	}, 1000);

	// Contact Form 7 callbacks
	document.addEventListener('wpcf7mailsent', function (e) {
		$.fancybox.close();
		$.fancybox.open('<div class="h3 popin is-alert">' + e.detail.apiResponse.message + '</div>');
		// var tl = gsap.timeline({paused : true});
		// tl.add(function(){
		// 	$('.contact__formulaire__group__reponse').addClass('is-active');
		// });
		// tl.fadeUp( $('.contact__formulaire__group__reponse__item > div'), {}, 0.2 );
		// tl.play();
	}, false);
});

$( document ).on('click', '.form__submit ', function(evt) {
	var el = $(evt.currentTarget);
	evt && evt.preventDefault();
	el.parents('form').eq(0).submit();
});

$( document ).on('click', '[data-goto-anchor]', function(evt) {
	var el = $(evt.currentTarget);
	var anchor = $(el).attr('data-goto-anchor');
	console.log('anchor', anchor);
	if ( $('#' + anchor).size() ) {
		menuToggler();
		var top = $('#' + anchor).offset().top;
		console.log('aaaa',  $('#'+anchor).offset().top )
		console.log('debug anchor scrollto', top);
		$('html, body').animate({scrollTop:$('#' + anchor).offset().top}, 500, 'easeInOutQuart');
	}
	else {
		cymasmooth.gotopagewithanchor = anchor;
		cymasmooth.goTo( $(el).attr('data-goto-href') );
	}
});

var refreshSelectClass = function(el){
	$(el).removeClass('has-no-value');
	$(el).removeClass('has-value');
	console.log('$(el).val()', $(el).val());
	if ( $(el).val().length > 0 ){
		$(el).addClass('has-value');
	}
	else {
		$(el).addClass('has-no-value');
	}
};

$(window).on('site:initPage', function(evt, el){
	form_file_input(el);
	// $(el).find('select').each(function(i, el){
	// 	$(el).on('change', function(){
	// 		refreshSelectClass(el);
	// 	});
	// 	refreshSelectClass(el);
	// });
});

$.fancybox.defaults.hash = false;
$.fancybox.defaults.hideScrollbar = false;
// disable poster cause fancybox use the image inside the link and its not what we wants
$.fancybox.defaults.video.tpl = '<video class="fancybox-video" controls controlsList="nodownload" postero="{{poster}}">' +
  '<source src="{{src}}" type="{{format}}" />' +
  'Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!' +
  "</video>";
// $.fancybox.defaults.arrows = false;
$.fancybox.defaults.buttons = [
	"zoom",
	//"share",
	// "slideShow",
	//"fullScreen",
	//"download",
	// "thumbs",
	"close"
];

$( document ).on('click', '[data-scrollto-with-hack]', function(evt) {
	var target_query = $(evt.currentTarget).attr('data-scrollto-with-hack');
	var y = parseFloat($(target_query).attr('data-decal-full'));
	console.log('scrollto y', y);
	$('html, body').animate({scrollTop:y + 10}, 1000, 'easeInOutQuart');
	// $('html, body').scrollTop(y);
});

var first_pass_app = true;
$(window).on('site:initPage', function(evt, el){
	$('body').removeClass('is-first-page');

	// var wrapmask = $('.reveal-faderightsml').wrapmask({cn:'ovh rel',mask:'',pos:'inner'});
	var delay = 0;
	// alert(first_pass_app)
	if ( first_pass_app ){
		delay = 0;
	}
	// alert(delay)
	setTimeout(function() {
		reveal( true );
		// paralax();
	}, delay);

	first_pass_app = false;
	// $('.gsap-paralax').each(function(i, el){
	$('.gsap-paralax, [data-paralax]').each(function(i, el){
		var h = $(el).height();
		console.log('h', h);
		var ratio = 0.25;
		if ( $(el).attr('data-paralax') ){
			ratio = parseFloat($(el).attr('data-paralax'))
		}
		h = h * ratio;
		gsap.set( el, {y:h} );

		gsap.to(el, {
			y: -h,
			ease: "none",
			scrollTrigger: {
				trigger: el,
				marker: 0,
				scrub: 1
			}
		});

		var scale = 0.1;
		var img_scale = 1 + ( scale * 2 );
		var y_pc = ( scale / img_scale ) * -100;
		if ( $(el).hasClass('gsap-paralax-inner') ) {
			var img = $(el).find('img');
			gsap.set(img, {scale:img_scale, yPercent:y_pc});
			gsap.to(img, {
				yPercent: -y_pc,
				ease: "none",
				scrollTrigger: {
					trigger: el,
					marker: 0,
					scrub: 1
				}
			});
		}

	});


	if ( MQ(768) ){
		// $('.bando__wrap').each(function(i, el){
		// 	// var h = $(el).height();
		// 	// console.log('h', h);
		// 	// var ratio = 0.25;
		// 	// if ( $(el).attr('data-paralax') ){
		// 	// 	ratio = parseFloat($(el).attr('data-paralax'))
		// 	// }
		// 	// h = h * ratio;
		// 	// gsap.set( el, {y:h} );

		// 	gsap.fromTo($(el).find('.bando'), {
		// 		yPercent: -25
		// 	}, {
		// 		yPercent: 25,
		// 		ease: "none",
		// 		scrollTrigger: {
		// 			trigger: el,
		// 			markers: 0,
		// 			scrub: 0
		// 		}
		// 	});

		// });
		
		// $(el).find('.ott__bando').each(function(i, el){
		// 	var tl = gsap.timeline({paused : true});
		// 	tl.fromTo( $(el).find('.ott__bando__inner'), {
		// 		y: '-20%',
		// 		transformOrigin: '50% 50%'
		// 	}, {
		// 		// scale: 4,
		// 		y: '+20%',
		// 		transformOrigin: '50% 50%',
		// 		ease: 'none'
		// 	} )
		// 	var stbb = ScrollTrigger.create({
		// 		animation: tl,
		// 		trigger: el,
		// 		// start: "top top",
		// 		// end: function(){
		// 		// 	return '+='+$(window).height() * 1
		// 		// },
		// 		// markers: 1,
		// 		// pin: true,
		// 		// pinSpacing: false,
		// 		// pinSpacing: true,
		// 		// once: true,
		// 		scrub: 0

		// 	});
		// });

		$(el).find('.pageheader__page__headero').each(function(i, el){
			var tlb = gsap.timeline({paused : true})
			tlb.fromTo( $(el).find('.pageheader__page__header__video video, .pageheader__page__header__visuel'), {
				scale:1.001,
				y: 0,
				ease: 'none'
			}, {
				scale:1.05,
				y: '100%',
				ease: 'none'
			} )
			var stbb = ScrollTrigger.create({
				animation: tlb,
				trigger: el,
				start: "top top",
				end: function(){
					return '+='+$(window).height() * 1
				},
				// markers: 1,
				// pin: true,
				// pinSpacing: false,
				// pinSpacing: true,
				// once: true,
				scrub: 0

			});
		});
	}


	setTimeout(function() {
		ScrollTrigger.refresh(true);
	}, 150); 
});

$(window).on('resize', function(){
	// alert('scroll trigger refresh')
	// ScrollTrigger.refresh();
});

$('.header__menu__span').on('click', function(){
	$('body').removeClass('is-main-menu-open')
});

var generateGooeyMvmt = function(prevBbox, nextBbox){
	var dummy = $('.experience__liste__group__blocs__head__items__mover');
	var tl = gsap.timeline({paused : true})
	tl.to(dummy, {
		x: nextBbox.left,
		scaleX: nextBbox.width * 0.01,
		ease: 'power2.out',
		duration: 0.5,
	});
	return tl;
	var offset = prevBbox.height;
	var mainMovementLeftToLeft = Math.abs(nextBbox.left - prevBbox.left);
	var mainMovementRightToRight = Math.abs(nextBbox.right - prevBbox.right);
	var mainMovement = mainMovementLeftToLeft;
	if ( nextBbox.left < prevBbox.left ){
		mainMovement = mainMovementRightToRight;
	}
	// au debut de l'anim le bord exterieur au mouvement (gauche si mouvement vesr a droite, droite si mouvement vesr la gauche) qui reste collé un petit temps, pendant que l'element commence déja a bouger (donc agrandir le width et en + décaler l'element vers la gauche si mouvement vers la gauche) 
	var firstMvmt = {
		width: prevBbox.width + offset,
		duration: offset
	};
	if ( nextBbox.left < prevBbox.left ){
		firstMvmt.x = prevBbox.left - offset;
	}
	console.log('firstMvmt', firstMvmt);
	tl.to( dummy, firstMvmt );
	var secondMovement = {
		width: nextBbox.width + offset,
		x: nextBbox.left,
		duration: mainMovement - offset
	};
	if ( nextBbox.left > prevBbox.left ){
		secondMovement.x = nextBbox.left - offset
	}
	console.log('secondMovement', secondMovement);
	tl.to( dummy, secondMovement );
	var thirdMovement = {
		width: nextBbox.width,
		duration: offset
	}
	if ( nextBbox.left > prevBbox.left ){
		thirdMovement.x = nextBbox.left
	}
	console.log('thirdMovement', thirdMovement);
	tl.to( dummy, thirdMovement );
	// ensuite le mouvement vers l'element final tout en gerant le width pour qu'au final qd il arrive l'element soit un peu plus large que la position finale de maniere à ce que le bord exterieur a la fin de l'anim (gauche si mouvement vers la droite, droite si mouvement vesr la gauche) se bloque la, 
	// mais qu'il y ai encore un petit mouvement qui ajuste width pour avoir la largeur finale ok avec un petit decalage si la position finale est sur la droite 
	return tl;
}

var onRenderPageEventCount = 0;
var onRenderPageEvent = function(url, record_visit, undefined){
	// scrollmenu.setMenuItems($('.home__scroll__menu__item').get());
	onRenderPageEventCount++;

	var html = $(this.next_page.html);
	var index = -1;
	var lis = html.find('.header .menu__item__li');
	for(var i=0,j=lis.length;i<j;i++){
		if ( lis.eq(i).hasClass('is-current') ){
			index = i;
		}
	}
	console.log('menu current index', index);
	setTimeout(function() {
		$('.header .menu__item__li').removeClass('is-current')
		console.log('index2', index);
		if ( index >= 0 ) {
			$('.header  .menu__item__li').eq(index).addClass('is-current');
		}
	}, 300);

	var index = -1;
	var lis = html.find('.header .menu__item');
	for(var i=0,j=lis.length;i<j;i++){
		if ( lis.eq(i).hasClass('is-current-link') ){
			index = i;
		}
	}
	console.log('menu current index', index);
	setTimeout(function() {
		if ( onRenderPageEventCount > 1 && $('.header__menu__nav__inner .is-current-link').length && index >= 0 ){ // animate
			var prev = $('.header__menu__nav__inner .is-current-link');
			var prevBbox = $(prev).bbox( $('.header__menu__nav__inner') );
			console.log('prevBbox', prevBbox);
			var next = $('.header  .menu__item').eq(index);
			var nextBbox = $(next).bbox( $('.header__menu__nav__inner') );
			console.log('nextBbox', nextBbox);
			var tl = gsap.timeline({paused : true});
			tl.add(function(){
				$('.header__menu__nav__inner').addClass('disable-transition')[0].offsetHeight;
			});
			tl.set($('.header__menu__nav__inner__dummy'), {
				opacity: 1,
				x: prevBbox.left,
				width: prevBbox.width,
			}, '+=0.01');
			tl.add(function(){
				$('.header .menu__item').removeClass('is-current-link');
			});
			var tlb = generateGooeyMvmt( prevBbox, nextBbox );
			
			tl.fromTo(tlb, {
				progress: 0
			}, {
				progress: 1,
				ease: 'power2.inOut',
				duration: 0.5,
			});
			tl.add(function(){
				$('.header  .menu__item').eq(index).addClass('is-current-link');
			});
			tl.set($('.header__menu__nav__inner__dummy'), {
				opacity: 0
			});
			tl.add(function(){
				$('.header__menu__nav__inner').removeClass('disable-transition')[0].offsetHeight;
			}, '+=0.01');
			tl.play();
		}
		else {
			$('.header .menu__item').removeClass('is-current-link')
			console.log('index2', index);
			if ( index >= 0 ) {
				$('.header  .menu__item').eq(index).addClass('is-current-link');
			}
		}
	}, 10);

	$('.header__contact__link').removeClass('is-current');
	var founded = html.find('.header__contact__link.is-current').size();
	// alert(founded);
	setTimeout(function() {
		if ( founded > 0 ) {
			$('.header__contact__link').addClass('is-current');
		}
	}, 300);
	

	var langs_a = $('a.lang__cta');

	// html.find('.header__langs a').each(function(i, el){
	html.find('a.lang__cta').each(function(i, el){
		langs_a.eq(i).attr('href', $(el).attr('href'))
	})
	

	var langs_a = $('a.lang__link');

	// html.find('.header__langs a').each(function(i, el){
	html.find('a.lang__link').each(function(i, el){
		langs_a.eq(i).attr('href', $(el).attr('href'))
	})
	
};

cymasmooth.registerFuncMulti( 'onRenderPage', onRenderPageEvent );

$(window).on('cymasmooth:statechanging', function(){
	console.log('$(window).scrollTop()', $(window).scrollTop());
	var h = $('.page__wrap').outerHeight();
	console.log('h', h);
	var scroll_top = $(window).scrollTop();
	$('<div class="pw__dummy" />').css({height:h,opacity:0}).insertBefore( $('.page__wrap') );
	var p = $('<div class="page__wrap__fixed" />').css({position: 'fixed',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		overflow: 'hidden'}).insertBefore( $('.page__wrap') );
	$('.page__wrap').css({
		position: 'absolute',
		left: 0,
		right: 0,
		height: h,
		top: -scroll_top
	}).appendTo(p);
	if ( $('.services__content').length ){
		console.log('service--content__a', $('.services__content').get(0).innerHTML);
	}
});

// document.addEventListener('keydown', function(event) {
//   if (event.key === 'd' || event.key === 'D') {
//     alert('d')
//     $(window).trigger('cymasmooth:statechanging');
//   }
// });

$(window).on('cymasmoothv2:onLinkClicked', function(evt, evtb, el, url){
	if ( MQ(768) ){
		return;
	}
	console.log('cymasmoothv2:onLinkClicked', arguments);
	if ( $(el).hasClass('actus__menu__item__link') == false ){
		return;
	}
	console.log('force scroll overlowx to stay at position');
	var actus__menu__items = $(el).closest('.actus__menu__items');
	var left = actus__menu__items.scrollLeft() * -1;
	console.log('left', left);
	$(el).closest('.actus__menu__items__wrap').height( actus__menu__items.height() );
	actus__menu__items.css({
		'transform': `translateX(${left}px)`,
		position: 'absolute'
	});
	// debugger;
	
});

if ( MQ(768) ) {
	$(window).trigger('reveal:changelimit', 0.75);
}

$( document ).on('click', '[data-popup="open"]', function(evt) {
	var el = $(evt.currentTarget);
	$('body').addClass('is-popup-open');
});

$( document ).on('click', '[data-popup="close"]', function(evt) {
	var el = $(evt.currentTarget);
	$('body').removeClass('is-popup-open');
});


$( document ).on('click', '.cta', function(evt) {
	var cta = $(evt.currentTarget).get(0);
	
	const rect = cta.getBoundingClientRect();

	const x = evt.clientX - rect.left;
	const y = evt.clientY - rect.top;

	// distances vers les coins
	const distX = Math.max(x, rect.width - x);
	const distY = Math.max(y, rect.height - y);

	const radius = Math.sqrt(distX * distX + distY * distY);

	const ripple = document.createElement('span');
	ripple.className = 'cta__ripple';

	ripple.style.left = x + 'px';
	ripple.style.top = y + 'px';
	ripple.style.width = ripple.style.height = radius * 2 + 'px';

	cta.appendChild(ripple);

	ripple.addEventListener('animationend', () => {
		ripple.remove();
	});
});


$(window).on('site:initPage', function(evt, el){
	$(el).find('.protected__button').on('click', function() {
        var password = $('input[name="pwd"]').val();
        var post_id = $('input[name="postid"]').val();
        var ajaxurl = $('input[name="ajaxurl"]').val();

        $.ajax({
            url: ajaxurl, // L'URL AJAX de WordPress
            type: 'POST',
            data: {
                action: 'check_pass', // Action définie dans le PHP
                password: password,
                post_id: post_id
            },
            beforeSend: function() {
                $('.protected__submit__loader').addClass('is-active'); // Afficher le loader
            },
            success: function(response) {
                $('.protected__submit__loader').removeClass('is-active'); // Masquer le loader
                console.log('response', response);
                if ( response == '1' ){
	                cymasmooth.goTo( window.location );
                }
                else {
                	$.fancybox.close();
					$.fancybox.open('<div class="h3 popin is-alert">Password Incorrect</div>');
                }
                // if (response.success) {
                //     location.reload(); // Recharger la page pour afficher le contenu
                // } else {
                //     alert(response.data); // Afficher le message d'erreur
                // }
            }
        });
    });
});

import Lenis from 'lenis';

// Initialize a new Lenis instance for smooth scrolling
const lenis = new Lenis();

// Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
lenis.on('scroll', ScrollTrigger.update);

// Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
// This ensures Lenis's smooth scroll animation updates on each GSAP tick
gsap.ticker.add((time) => {
  lenis.raf(time * 1000); // Convert time from seconds to milliseconds
});

// Disable lag smoothing in GSAP to prevent any delay in scroll animations
gsap.ticker.lagSmoothing(0);

$(window).trigger('reveal:setLenisAsScrollManager', {
	lenis: lenis
});

$(document).on('afterShow.fb', function(e, instance, current) {
	console.log('aftershow fb');
	console.log(lenis);
	$('.fancybox-slide').attr('data-lenis-prevent', '');
    // if (typeof lenis !== 'undefined') {
    //     lenis.stop();
    // }
});

$(document).on('afterClose.fb', function(e, instance, current) {
	console.log('afterclose fb');
	console.log(lenis);
    // if (typeof lenis !== 'undefined') {
    //     lenis.start();
    // }
});


$(window).on('site:initPage', function(evt, el){
	$(el).find('.services__intro__item').each(function(i, el){

		var bboxParent = $(el).find('.services__intro__group__txts').bbox();
		var bboxChild = $(el).find('.services__intro__group__texte').bbox();
		console.log('bboxParent', bboxParent);
		console.log('bboxChild', bboxChild);

		var padding = bboxParent.height - bboxChild.bottom;
		$('.services__intro__group__video').css('padding-bottom', padding);

		// let tl = gsap.timeline({
		// 	scrollTrigger: {
		// 		trigger: el,
		// 		start: "top top",
		// 		end: "+=500", // mini zone pour forcer un vrai passage
		// 		scrub: true,
		// 		pin: true,
		// 		pinSpacing: false,
		// 		// once: false,
		// 		// markers: 1,
		// 	}
		// });
		
		// tl.to({}, {duration: 1});

	});
});

// ScrollTrigger.refresh();
$(window).on('site:initPage', function(evt, el){
	$(el).find('.services__liste__group__blocs__videos__video').each(function(i, el){

		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: "center center",
				end: "+=1", // mini zone pour forcer un vrai passage
				scrub: true,
				// once: false,
				// markers: 1,
			}
		});
		
		tl.to({}, {duration: 1});

		tl.add(function(){
			const dir = tl.scrollTrigger.direction;

			console.log('Before PILE AU CENTRE');
			console.log('Before index:', i);
			console.log('Before direction:', dir);

			$('.services__liste__group__blocs__item__txts')
				.removeClass('is-active')
				.eq( i + Math.max(0, dir) )
				.addClass('is-active')
		});

		tl.to({}, {duration: 1});

	});
});


$( document ).on('click', '[data-target-from]', function(evt) {
	var el = $(evt.currentTarget);
	if ( el.hasClass('is-active') ) {
		return;
	}
	var q = el.attr('data-target-from');
	$('[data-target-to]').slideUp(500, 'easeInOutQuart');
	// $('[data-target-to]').removeClass('is-active');
	$('[data-target-to="'+q+'"]').slideDown(500, 'easeInOutQuart');
	// $('[data-target-to="'+q+'"]').addClass('is-active');
	$('[data-target-from]').removeClass('is-active');
	el.addClass('is-active');

	var targetY = $('.experience__liste__group__blocs__anchor').offset().top;
	// console.log('targetY', targetY);
	targetY = Math.max(0, Math.min(targetY, $('body').height() - $(window).height()));
	// console.log('targetY', targetY);
	$('html, body').animate({scrollTop:targetY}, 500, 'easeInOutQuart');
});


$(window).on('site:initPage', function(evt, el){
	$(el).find('.about__recognitions__group__video__wrapb').each(function(i, el){

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: "top bottom",
				end: "bottom top",
				// end: "+=" + ( (vh*0.5 + 1 * vh + vh *2) * 2 ),
				scrub: true,
				// pin: true,
				// markers: 1,
				// anticipatePin: 1,
				// pinSpacing: false,
			}
		});

		tl.fromTo( $(el).find('.about__recognitions__group__video'), {
			y: '-50%',
		}, {
			y: '50%',
			ease: 'none',
		} )

	});
});


$(window).on('site:initPage', function(evt, el){
	$(el).find('.projetspost__intro__group__video__wrap__wrap').each(function(i, el){

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: "top top",
				end: "bottom top",
				// end: "+=" + ( (vh*0.5 + 1 * vh + vh *2) * 2 ),
				scrub: true,
				// pin: true,
				// markers: 1,
				// anticipatePin: 1,
				// pinSpacing: false,
			}
		});

		tl.fromTo( $(el).find('.projetspost__intro__group__video__wrap'), {
			y: '0%',
		}, {
			y: '50%',
			ease: 'none',
		} )

	});
});


var scrollmenu = require('scrollmenu');
var canChangeScrollMenuLine = true;
$(window).on('site:initPage', function(evt, el){
	if ( MQ(769) ) {
		$(el).find('.experience__liste__content').each(function(i, el){
			scrollmenu.setMenuItems($(el).find('[data-scrollto]').get(), {
				scrollitems: $(el).find('.experience__anchor')
			});
			$(el).find('.experience__liste__group__blocs__head__titre').hover(function(){
				var prevIndex = $('.experience__liste__group__blocs__head__titre.is-selected').closest('.experience__liste__group__blocs__head__item').index();
				var nextIndex = $(this).closest('.experience__liste__group__blocs__head__item').index();
				getExpMenuItemBbox(prevIndex, nextIndex);
			}, function(){
				var prevIndex = $(this).closest('.experience__liste__group__blocs__head__item').index();
				var nextIndex = $('.experience__liste__group__blocs__head__titre.is-selected').closest('.experience__liste__group__blocs__head__item').index();
				getExpMenuItemBbox(prevIndex, nextIndex);
			});
		})
	}
});

$(window).on('scrollmenu:indexChanged', function(evt, previousIndex, nextIndex){
	getExpMenuItemBbox(previousIndex, nextIndex);
});

$(window).on('cymasmooth:onGoTo', function(evt){
	scrollmenu.clear();
});

var getExpMenuItemBbox = function(previousIndex, nextIndex){
	if ( canChangeScrollMenuLine == false ) {
		return;
	}
	console.log('arguments', arguments);
	var prevBbox = {width:0,left:0};
	var nextBbox = {width:0,left:0};
	if ( previousIndex >= 0 ) {
		prevBbox = $('.experience__liste__group__blocs__head__titre .inner').eq(previousIndex).bbox( $('.experience__liste__group__blocs__head__items') );
	}
	if ( nextIndex >= 0 ) {
		nextBbox = $('.experience__liste__group__blocs__head__titre .inner').eq(nextIndex).bbox( $('.experience__liste__group__blocs__head__items') );
	}
	console.log('debug', prevBbox, nextBbox);
	var tl = generateGooeyMvmt(prevBbox, nextBbox);
	tl.play();
};

$(window).on('scrollto:start', function(){
	canChangeScrollMenuLine = false;
});

$(window).on('scrollto:end', function(){
	canChangeScrollMenuLine = true;

});

$(window).on('site:initPage', function(evt, el){
	$('.window__img').each(function(i, el){
		var wrapmask = $(el).wrapmask({cn:'ovh rel'});
		console.log('wrapmask', wrapmask);
		gsap.set( wrapmask.childs, {
			scale: 1.4
		});

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: "top bottom",
				end: "bottom top",
				// end: "+=" + ( (vh*0.5 + 1 * vh + vh *2) * 2 ),
				scrub: true,
				// pin: true,
				// markers: 1,
				// anticipatePin: 1,
				// pinSpacing: false,
			}
		});

		tl.fromTo( wrapmask.childs, {
			y: '-20%',
		}, {
			y: '20%',
			ease: 'none',
		} )

	});
});

$(window).on('site:initPage', function(evt, el){
	$('.window__img__sml').each(function(i, el){
		var wrapmask = $(el).wrapmask({cn:'ovh rel'});
		console.log('wrapmask', wrapmask);
		gsap.set( wrapmask.childs, {
			scale: 1.1
		});

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: "top bottom",
				end: "bottom top",
				// end: "+=" + ( (vh*0.5 + 1 * vh + vh *2) * 2 ),
				scrub: true,
				// pin: true,
				// markers: 1,
				// anticipatePin: 1,
				// pinSpacing: false,
			}
		});

		tl.fromTo( wrapmask.childs, {
			y: '-5%',
		}, {
			y: '5%',
			ease: 'none',
		} )

	});
});

// $(window).on('site:initPage', function(evt, el){
// 	setTimeout(function() {
// 		$('.headerbloc__bloc__header').each(function(i, el){
// 			const tl = gsap.timeline({
// 				scrollTrigger: {
// 					trigger: el,
// 					start: "top bottom",
// 					end: () => "+=" + el.offsetHeight, // dynamique
// 					scrub: true,
// 					invalidateOnRefresh: true,
// 					// pin: true,
// 					// markers: 1,
// 					// anticipatePin: 1,
// 					// pinSpacing: false,
// 				}
// 			});

// 			tl.fromTo( $(el).find('.headerbloc__bloc__header__item__bg__inner'), {
// 				y: '-50%',
// 			}, {
// 				y: '0%',
// 				// ease: 'none',
// 				// ease: CustomEase.create("custom", "M0,0 C0.251,0.739 0.246,1 1,1 "),
// 				ease: 'power2.out',
// 			} )

// 		});
// 	}, 500);
// });

$(window).on('site:initPage', function(evt, el){
	setTimeout(function() {
		$('.headerbloc__bloc__headero').each(function(i, el){
			// var lines = new SplitText($(el).find('.headerbloc__bloc__header__group__sous__titre .inner'), {type:'lines'}).lines;
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: el,
					start: "top 75%",
					// end: () => "+=" + el.offsetHeight, // dynamique
					// scrub: true,
					// invalidateOnRefresh: true,
					// pin: true,
					markers: 1,
					// anticipatePin: 1,
					// pinSpacing: false,
				}
			});

			tl.set( $(el).find('.headerbloc__bloc__header__item__txts'), {opacity: 1} );

			tl.from( $(el).find('.headerbloc__bloc__header__item__txts__bg'), {
				duration : 1.6,
				opacity: 0,
				scaleX: 0.5,
				ease: CustomEase.create("custom", "M0,0 C0.251,0.739 0.246,1 1,1 "),
			}, 0 );

			tl.from( $(el).find('.headerbloc__bloc__header__group__sous__titre .inner div').add( $(el).find('.headerbloc__bloc__header__group__titre .inner') ), {
				// y: '100%',
				y: function(i, el, els){
					return $(el).outerHeight() * ( 1 + (i*0.25) );
				},
				opacity: 0,
				duration: 1.6,
				ease: CustomEase.create("custom", "M0,0 C0.251,0.739 0.246,1 1,1 "),
				stagger: 0.02,
			}, 0.1)

		});
	}, 500);
});

$(window).on('site:initPage', function(evt, el){
	setTimeout(function() {
		$('.home__intro__sectiono').each(function(i, el){
			// var lines = new SplitText($(el).find('.headerbloc__bloc__header__group__sous__titre .inner'), {type:'lines'}).lines;
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: el,
					start: "top top",
					end: () => "+=" + el.offsetHeight, // dynamique
					scrub: true,
					invalidateOnRefresh: true,
					pin: true,
					// markers: 1,
					// anticipatePin: 1,
					pinSpacing: false,
				}
			});

			tl.to( $(el).find('.home__intro__mw'), {
				y: '-50%',
				ease: 'power1.in'
			} )

		});
	}, 50);
});

$(window).on('site:initPage', function(evt, el){
	setTimeout(function() {
		$('.home__projet__group__visuelo').each(function(i, el){
			// var lines = new SplitText($(el).find('.headerbloc__bloc__header__group__sous__titre .inner'), {type:'lines'}).lines;
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: el,
					start: "top bottom",
					end: () => "top top", // dynamique
					scrub: true,
					invalidateOnRefresh: true,
					// pin: true,
					markers: 1,
					// anticipatePin: 1,
					// pinSpacing: false,
				}
			});

			tl.fromTo( $(el).find('.home__projet__group__visuel__inner'), {
				scale: 1.25,
			}, {
				scale: 1.01,
				ease: "slow(0.5, 0.8)",
				duration: 1,
			} )

		});
	}, 500);
});

$(window).on('site:initPage', function(evt, el){
	setTimeout(function() {
		$('.home__intro__group .anim__measure').each(function(i, measure){
			// var lines = new SplitText($(el).find('.headerbloc__bloc__header__group__sous__titre .inner'), {type:'lines'}).lines;
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: measure,
					start: "top top",
					end: () => "bottom top",
					scrub: true,
					invalidateOnRefresh: true,
					// pin: true,
					// markers: 0,
					// anticipatePin: 1,
					// pinSpacing: false,
				},
				// defaults: { ease: "slow(0.5, 0.8)", duration: 1, force3D: true }
				defaults: { ease: "none", duration: 1, force3D: true }
			});

			var decal = 0.07;

			tl.fromTo( $(el).find('.home__intro__group__visuel'), {
				scale: 1.25,
			}, {
				scale: 1.01,
				duration: 1 - decal,
			}, decal );

			tl.fromTo( $(el).find('.home__intro__group__visuel__wrap'), {
				// scale: 1.25,
				clipPath: "inset(50%)",
			}, {
				// scale: 1.01,
				clipPath: "inset(0%)",
				duration: 1 - decal,
			}, decal );

			if ( MQ(-768) ) {
				var distance = $('.home__intro__group__left').bbox().bottom + 20;

				tl.to( $(el).find('.home__intro__group__left, .home__intro__group__mots'), {
					y: -distance,
					duration: 1,
				}, 0 );

				tl.to( $(el).find('.home__intro__group__right'), {
					y: distance,
					duration: 1,
				}, 0 );
			}
			else {
				var distance = $('.home__intro__group__left').bbox().right + 20;

				tl.to( $(el).find('.home__intro__group__left'), {
					x: -distance,
					duration: 1,
				}, 0 );

				tl.to( $(el).find('.home__intro__group__right'), {
					x: distance,
					duration: 1,
				}, 0 );
			}


			tl.to( $(el).find('.home__intro__group__mots, .home__intro__group__footer'), {
				opacity: 0,
				duration: 0.25,
			}, 0 );

		});
	}, 500);
});

// $(window).on('site:initPage', function(evt, el){
$(window).on('sksmooth:showAnimStart', function(evt, el){
	var heights = 0;
	$(el).find('.histoirespost__mea__accueil__section').each(function(i, titre){
		var h = $(titre).find('.histoirespost__mea__accueil__group__titre').bbox().height;
		$(titre).css('--height', heights + 'px');
		$(titre).css('--item-header-height', h + 'px');
		heights += h;
	});
});

$(window).on('site:initPage', function(evt, el){
	$(el).find('.about__textes__group__textes__wrap__wrap').each(function(i, el){
		var linesA = new SplitText($(el).find('.about__textes__group__texte__2 .inner'), {type:'lines'}).lines;
		var linesB = new SplitText($(el).find('.about__textes__group__texte__3 .inner'), {type:'lines'}).lines;
		var nbLines = Math.max(linesA.length, linesB.length);
		for(var i=0,j=nbLines;i<j;i++){
			$('<div class="rel ovh line"></div>').appendTo($(el).find('.about__textes__group__texte__4'));
		}
		linesA.forEach(function(line, i){
			$(line).clone().addClass('lineA wc').appendTo($('.about__textes__group__texte__4 .line').eq(i));
		});
		linesB.forEach(function(line, i){
			$(line).clone().addClass('lineB wc').css('position', 'absolute').appendTo($('.about__textes__group__texte__4 .line').eq(i));
		});
		// return;
		gsap.set($(el).find('.about__textes__group__texte__4 .lineB'), {yPercent:101});

		// var tlb = gsap.timeline({paused : true});
		// tlb.fromTo( $(el).find('.about__textes__group__texte__4 .lineA'), {
		// 	yPercent: 0
		// }, {
		// 	yPercent: -101,
		// 	duration: 0.6,
		// 	ease: 'power2.out',
		// }, 0);
		// tlb.fromTo( $(el).find('.about__textes__group__texte__4 .lineB'), {
		// 	yPercent: 101
		// }, {
		// 	yPercent: 0,
		// 	duration: 0.6,
		// 	ease: 'power2.out',
		// }, 0);


	    let tl = gsap.timeline({
	        scrollTrigger: {
	            trigger: $(el).find('.about__textes__group__textes__wrap__wrap__animator'),
	            start: "top top",
	            end: "+=1",
	            scrub: true,
	        }
	    });
	    
	    tl.to({}, {duration: 1});
	    tl.add(function(){
	        const dir = tl.scrollTrigger.direction;
	        if ( dir == 1 ) {
	        	// tlb.play();
	        	gsap.to( $(el).find('.about__textes__group__texte__4 .lineA'), {
	        		yPercent: -101,
	        		duration: 0.6,
	        		ease: 'power2.out',
	        	});
	        	gsap.to( $(el).find('.about__textes__group__texte__4 .lineB'), {
	        		yPercent: 0,
	        		duration: 0.6,
	        		ease: 'power2.out',
	        	});
	        }
	        else {
	        	// tlb.reverse();
	        	gsap.to( $(el).find('.about__textes__group__texte__4 .lineA'), {
	        		yPercent: 0,
	        		duration: 0.6,
	        		ease: 'power2.out',
	        	});
	        	gsap.to( $(el).find('.about__textes__group__texte__4 .lineB'), {
	        		yPercent: 101,
	        		duration: 0.6,
	        		ease: 'power2.out',
	        	});
	        }
	    });
	    tl.to({}, {duration: 1});
	});
});

$(window).on('slides:swiperBeforeChange', function(evt, swiper, oldSlide, newSlide){
	if ( $(newSlide).closest('.citations__tpl').length ) {
		var $item = $(newSlide);
		// el = $(el).find('.swiper-slide-active');
		var tl = new TimelineMax({paused : true, defaults: { ease: "expo.out", duration: 1.2, force3D: true }});
		if (!$item.data('lines')) {
			var lines = new SplitText($item.find('.citations__tpl__gp__citation .inner p'), {type:'lines'}).lines;
			$item.data('lines', lines);
		}
		tl.fadeUp( $item.data('lines'), {
			
		}, 0);
		tl.fadeUp( $item.find('.citations__tpl__gp__visuel'), {

		}, 0.15);
		if ($item.find('.citations__tpl__gp__nom__line').length) {
			tl.from($item.find('.citations__tpl__gp__nom__line'), {
				scaleX: 0.8,
				opacity: 0,
			}, 0.3)
			tl.from($item.find('.citations__tpl__gp__nom__inner'), {
				opacity: 0,
				ease: 'none',
			}, 0.3)
		}
		setTimeout(function() {
			tl.play();
		}, 100);
	}
	if ( $(newSlide).closest('.formation__activations').length ) {
		var $item = $(newSlide);
		// el = $(el).find('.swiper-slide-active');
		var tl = new TimelineMax({paused : true, defaults: { ease: "expo.out", duration: 1.2, force3D: true }});
		tl.from($item.find('.formation__activations__group__slides__visuel'), {
			scale: 1.05,
			duration: 1.6,
			ease: 'power1.out',
		})
		tl.from($item.find('.formation__activations__group__slides__titre, .formation__activations__group__slides__textes'), {
			opacity: 0,
			duration: 1.2,
			ease: 'none',
		}, 0.2);
		setTimeout(function() {
			tl.play();
		}, 100);
	}
});

$(window).on('site:initPage', function(evt, el){
	setTimeout(function() {
		$('.contact__visuel__wrap__wrap').each(function(i, el){
			// var lines = new SplitText($(el).find('.headerbloc__bloc__header__group__sous__titre .inner'), {type:'lines'}).lines;
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: $(el).find('.contact__visuel__wrap__wrap__animator'),
					start: "top top",
					end: () => "bottom top", // dynamique
					scrub: true,
					invalidateOnRefresh: true,
					// pin: true,
					markers: 0,
					// anticipatePin: 1,
					// pinSpacing: false,
				}
			});

			tl.fromTo( $(el).find('.contact__visuel'), {
				scale: 1,
				y: 0,
			}, {
				scale: 1.03,
				y: -15,
				ease: "none",
				duration: 1,
			} )

		});
	}, 500);
});

$(window).on('site:initPage', function(evt, el){
	$(el).find('.home__intro__item').on('touchstart', function(e) {
	    // On enregistre la position de départ
	    var touch = e.originalEvent.touches[0];
	    $(this).data('startX', touch.pageX);
	    $(this).data('startY', touch.pageY);
	    $(this).data('hasMoved', false);
	}).on('touchmove', function(e) {
	    // Si l'utilisateur bouge de plus de 10px, on considère que c'est un scroll/swipe
	    var touch = e.originalEvent.touches[0];
	    var deltaX = Math.abs(touch.pageX - $(this).data('startX'));
	    var deltaY = Math.abs(touch.pageY - $(this).data('startY'));

	    if (deltaX > 10 || deltaY > 10) {
	        $(this).data('hasMoved', true);
	    }
	}).on('touchend', function(e) {
	    // On ne déclenche l'action que si le doigt n'a pas bougé
	    if (!$(this).data('hasMoved')) {
	        console.log("Touch pur détecté (pas de scroll) !");
	        // Ton code ici
	        var targetY = $('.home__anchor').offset().top;
	        console.log('targetY', targetY);
	        targetY = Math.max(0, Math.min(targetY, $('body').height() - $(window).height()));
	        console.log('targetY', targetY);
	        $('html, body').animate({scrollTop:targetY}, 1500, 'easeInOutQuart');
	    }
	});
});

require('./em-projets.js');

$(window).on('site:initPage', function(evt, el){
	
	// 1. ANCRE & NETTOYAGE : Sécurité si le container n'existe pas sur cette page
	const container = el.querySelector ? el.querySelector('.home__galerie__items') : document.querySelector('.home__galerie__items');
	
	// Si le container n'est pas sur la page, on s'assure de couper les timers globaux s'il y en avait
	if (!container) {
		if (window.cursorTrailMobileTimer) {
			clearInterval(window.cursorTrailMobileTimer);
			window.cursorTrailMobileTimer = null;
		}
		return; // On stoppe l'exécution ici
	}

	// ===== CONFIGURATION =====
	const DROP_EVERY_PX = 50;   // Distance en px avant de lâcher une image
	const DROP_MIN_MS   = 120;  // Throttle (temps min en ms entre deux images)
	const MAX_VISIBLE   = 7;    // Nombre max d'images visibles (FIFO)
	const MIN_SIZE_PX   = 150;  // Taille minimale de secours
	const ANIM_MS       = 300;

	// Initialisation du container
	const csContainer = window.getComputedStyle(container);
	// if (csContainer.position === 'static') container.style.position = 'relative';
	if (csContainer.overflow === 'visible') container.style.overflow = 'hidden';

	// Récupération des images sources déjà présentes et chargées dans le DOM
	const srcScope = el.querySelectorAll ? el : document;
	const srcNodes = Array.prototype.slice.call(srcScope.querySelectorAll('.home__galerie__assets img'));
	if (!srcNodes.length) return;

	// On extrait directement les sources et les dimensions naturelles (déjà dispo car chargées)
	let metaList = srcNodes.map(img => ({
		src: img.getAttribute('src') || img.src,
		w: img.naturalWidth || 1000,
		h: img.naturalHeight || 750
	}));

	// Mélange (Shuffle) du tableau de métadonnées
	for (let i = metaList.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		const t = metaList[i]; metaList[i] = metaList[j]; metaList[j] = t;
	}

	// ===== INITIALISATION DU POOL =====
	const pool = metaList.map(meta => {
		const imgEl = document.createElement('img');
		imgEl.decoding = 'async';
		imgEl.loading = 'eager';
		imgEl.draggable = false;
		imgEl.src = meta.src;
		imgEl.dataset.w = meta.w;
		imgEl.dataset.h = meta.h;

		imgEl.style.position = 'absolute';
		imgEl.style.pointerEvents = 'none';
		imgEl.style.userSelect = 'none';
		imgEl.style.willChange = 'transform';
		imgEl.style.backfaceVisibility = 'hidden';
		imgEl.style.webkitBackfaceVisibility = 'hidden';
		imgEl.style.transformOrigin = '50% 50%';
		imgEl.style.left = '0px';
		imgEl.style.top  = '0px';
		imgEl.style.transform = 'translate3d(-9999px,-9999px,0)'; // Parked d'entrée

		container.appendChild(imgEl);
		return imgEl;
	});

	const visibleQueue = [];
	const visibleSrcs  = new Set();

	function parkOld(imgEl){
		imgEl.style.transform = 'translate3d(-9999px,-9999px,0)';
		imgEl.style.zIndex = '';
	}

	function park(imgEl){
		// On applique la transition de sortie (fondu + rétrécissement)
		imgEl.style.transition = 'transform ' + (ANIM_MS * 0.4) + 'ms ease-in, opacity ' + (ANIM_MS * 0.4) + 'ms linear';
		imgEl.style.opacity = '0';
		
		// On extrait le translate3d actuel de la chaîne de caractères pour ne garder que la position sans casser le scale
		const currentTransform = imgEl.style.transform.split('scale')[0].trim();
		imgEl.style.transform = currentTransform + ' scale(0.75)';

		// On attend la fin de l'animation pour parquer définitivement l'élément
		setTimeout(() => {
			// Sécurité : on ne parque que si l'image n'a pas été réutilisée / réaffichée entre temps
			if (imgEl && imgEl.style.opacity === '0') {
				imgEl.style.transition = 'none';
				imgEl.style.transform = 'translate3d(-9999px,-9999px,0) scale(0.85)';
				imgEl.style.zIndex = '';
			}
		}, ( ANIM_MS * 0.5 ));
	}

	let pickIndex = 0;
	function pickUnique(){
		let tries = pool.length;
		while (tries--){
			const imgEl = pool[pickIndex++ % pool.length];
			if (!visibleSrcs.has(imgEl.src)) return imgEl;
		}
		if (visibleQueue.length){
			const oldest = visibleQueue.shift();
			visibleSrcs.delete(oldest.src);
			park(oldest);
		}
		return pool[pickIndex++ % pool.length];
	}

	function clamp(v, min, max){ return Math.max(min, Math.min(max, v)); }

	function innerBounds(){
		const r = container.getBoundingClientRect();
		const cs = window.getComputedStyle(container);
		const pl = parseFloat(cs.paddingLeft) || 0, pr = parseFloat(cs.paddingRight) || 0;
		const pt = parseFloat(cs.paddingTop)  || 0, pb = parseFloat(cs.paddingBottom) || 0;

		return {
			left:   r.left + pl,
			top:    r.top  + pt,
			width:  Math.max(0, r.width  - pl - pr),
			height: Math.max(0, r.height - pt - pb),
			pl: pl,
			pt: pt
		};
	}

	const isCoarse = window.matchMedia('(pointer: coarse)').matches;
	function baseVW(){ return isCoarse ? 85 : 33; }

	function computeSize(imgEl, b){
		const base = Math.max(MIN_SIZE_PX, Math.round(window.innerWidth * (baseVW() / 100)));
		const nw = +imgEl.dataset.w || base;
		const nh = +imgEl.dataset.h || base;
		const portrait = nh >= nw;
		let w, h;

		if (portrait){
			h = Math.min(base, b.height);
			w = (nw / nh) * h;
			if (w > b.width){ w = b.width; h = (nh / nw) * w; }
		} else {
			w = Math.min(base, b.width);
			h = (nh / nw) * w;
			if (h > b.height){ h = b.height; w = (nw / nh) * h; }
		}
		return { w: Math.round(w), h: Math.round(h) };
	}

	let lastX = null, lastY = null, lastDropTime = 0, zTop = 1;

	function placeAt(clientX, clientY){
		const now = performance.now();
		if (now - lastDropTime < DROP_MIN_MS) return;

		const b = innerBounds();
		if (!b.width || !b.height) return;

		const imgEl = pickUnique();
		const size = computeSize(imgEl, b);

		const innerX = clientX - b.left;
		const innerY = clientY - b.top;

		const cx = clamp(innerX, size.w / 2, b.width  - size.w / 2);
		const cy = clamp(innerY, size.h / 2, b.height - size.h / 2);

		imgEl.style.width  = size.w + 'px';
		imgEl.style.height = size.h + 'px';

		const tx = b.pl + (cx - size.w / 2);
		const ty = b.pt + (cy - size.h / 2);

		// imgEl.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0)';
		// imgEl.style.zIndex = String(++zTop);

		// 1. Placement instantané à sa nouvelle position, mais transparent et scale réduit
		imgEl.style.transition = 'none';
		imgEl.style.opacity = '1';
		imgEl.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(0.92)';
		imgEl.style.zIndex = String(++zTop);

		// 2. On force le reflow du navigateur pour valider la position de départ
		void imgEl.offsetWidth;

		// 3. On applique l'animation d'apparition via une transition CSS injectée en ligne
		imgEl.style.transition = 'transform ' + ANIM_MS + 'ms cubic-bezier(0.215, 0.610, 0.355, 1.000), opacity ' + (ANIM_MS * 0.5) + 'ms linear';
		imgEl.style.opacity = '1';
		imgEl.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(1)';

		visibleQueue.push(imgEl);
		visibleSrcs.add(imgEl.src);

		if (visibleQueue.length > MAX_VISIBLE){
			const old = visibleQueue.shift();
			visibleSrcs.delete(old.src);
			park(old);
		}

		lastDropTime = now;
	}

	// Événement au survol
	function onPointerMove(e){
		const b = innerBounds();
		const x = e.clientX, y = e.clientY;

		if (x < b.left || x > b.left + b.width || y < b.top || y > b.top + b.height) return;

		if (lastX == null){
			lastX = x; lastY = y;
			placeAt(x, y);
			return;
		}

		const dx = x - lastX, dy = y - lastY, dist = Math.hypot(dx, dy);
		if (dist < DROP_EVERY_PX) return;

		const steps = Math.floor(dist / DROP_EVERY_PX);
		for (let i = 1; i <= steps; i++){
			const t = i / steps;
			placeAt(lastX + dx * t, lastY + dy * t);
		}
		lastX = x; lastY = y;
	}

	container.addEventListener('pointermove', onPointerMove, {passive:true});

	// ===== LOGIQUE MOBILE / INTERVALLIER =====
	function centeredPoint(b){
		const testEl = pool[0];
		const size = computeSize(testEl, b);
		const minX = size.w / 2, maxX = b.width - size.w / 2;
		const minY = size.h / 2, maxY = b.height - size.h / 2;
		const safeWidth = Math.max(0, maxX - minX);
		const safeHeight = Math.max(0, maxY - minY);

		const rx = minX + safeWidth * (0.2 + Math.random() * 0.6);
		const ry = minY + safeHeight * (0.2 + Math.random() * 0.6);

		return { x: b.left + rx, y: b.top + ry };
	}

	if (window.cursorTrailMobileTimer) {
		clearInterval(window.cursorTrailMobileTimer);
		window.cursorTrailMobileTimer = null;
	}

	if (isCoarse){

		setTimeout(function() {
			const b0 = innerBounds();
			for (let s = 0; s < Math.min(4, MAX_VISIBLE); s++){
				const p = centeredPoint(b0);
				placeAt(p.x, p.y);
			}
			window.cursorTrailMobileTimer = setInterval(function(){
				if (!document.body.contains(container)) {
					clearInterval(window.cursorTrailMobileTimer);
					return;
				}
				const b2 = innerBounds();
				const p2 = centeredPoint(b2);
				placeAt(p2.x, p2.y);
			}, Math.max(DROP_MIN_MS, 700));
		}, 2000);
		
	}
});

// $( document ).on('click', '[data-js-toggle-active]', function(evt) {
// 	var el = $(evt.currentTarget);
// 	var q = el.attr('data-js-toggle-active');
// 	$(q).toggleClass('is-active');
// });

$(window).on('site:initPage', function(evt, el){
	$(el).find('[data-js-toggle-active]').click(function(evt) {
		var el = $(evt.currentTarget);
		var q = el.attr('data-js-toggle-active');
		$(q).toggleClass('is-active');
	});
});

var classes = ['alternate__a', 'alternate__b', 'alternate__c'];
var currentIndex = 0;

// 1. On initialise le body avec la première classe ('alternate__a')
document.body.classList.add(classes[currentIndex]);

// 2. On fait tourner toutes les 2 secondes
// setInterval(function() {
//     // On vire la classe actuelle avant de changer
//     document.body.classList.remove(classes[currentIndex]);

//     // On passe à l'index suivant (le modulo % permet de revenir à 0 arrivé au bout)
//     currentIndex = (currentIndex + 1) % classes.length;

//     // On ajoute la nouvelle classe
//     document.body.classList.add(classes[currentIndex]);
// }, 2000);

$(window).on('site:initPage', function(evt, el){
	(function changeMainClassLoop() {
		console.log('loop');
		console.log($(el).find('.projetspost__infos__section').length);
		if ( $('.projetspost__infos__section').length == 0 ) {
			return;
		}
		// On vire la classe actuelle avant de changer
	    document.body.classList.remove(classes[currentIndex]);

	    // On passe à l'index suivant (le modulo % permet de revenir à 0 arrivé au bout)
	    currentIndex = (currentIndex + 1) % classes.length;

	    // On ajoute la nouvelle classe
	    document.body.classList.add(classes[currentIndex]);
	    setTimeout(changeMainClassLoop, 2000);
	})();
});

$(window).on('site:initPage', function(evt, el){
	$(el).find('.intro__group__gallerie__items img').hover(function(){
		var src = $(this).attr('src');
		var $next = $('<div class="intro__group__gallerie__hover__img" style="background-image:url('+src+');"></div>');
		var $previous = $('.intro__group__gallerie__hover__img');
		$next.appendTo($('.intro__group__gallerie__hover__imgs'));
		$next.get(0).offsetWidth;
		$('.intro__group__gallerie__hover').addClass('is-active');
		$next.addClass('is-active');
		$previous.removeClass('is-active');
		setTimeout(function() {
			$previous.remove();
		}, 300);
	}, function(){
		$('.intro__group__gallerie__hover').removeClass('is-active');
	});
});

$(window).on('collection-intro-done', function(){
	var imgs = $('.intro__group__gallerie__item img');
	var ways = [
		{x:-101,y:0},
		{x:101,y:0},
		{x:0,y:-101},
		{x:0,y:101},
	];

	(function runAnimation() {
		var els = $('.intro__group__gallerie__item:not(.not__pho)');
		
		// Le check : si l'élément n'est plus là, on sort et ça ne boucle plus
		if (els.length === 0) return;

		console.log('interval');
		var inner = $('<div class="inner"></div>').append( imgs.eq(Math.floor(Math.random() * imgs.length)).clone() );
		inner.css({position:'absolute',top:0});
		var randomWays = ways[Math.floor(Math.random() * 4)];
		var tl = gsap.timeline({paused : true})
		tl.from(inner, {
			xPercent: randomWays.x,
			yPercent: randomWays.y,
			ease: "expo.out",
			duration: 1.2,
		});
		var el = els.eq(Math.floor(Math.random() * els.length));
		var oldInner = el.find('.inner');
		el.append(inner);
		tl.add(function(){
			oldInner.remove();
			inner.css({position:'relative'});
		});
		tl.play();

		// On planifie le coup d'après
		setTimeout(runAnimation, 1500);
	})();
});


$(window).on('site:initPage', function(evt, el){
	setTimeout(function() {
		$('.collections__texte__item').each(function(i, el){
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: $(el).find('.texte__group__texte'),
					start: "top bottom",
					end: () => "bottom top", // dynamique
					scrub: true,
					invalidateOnRefresh: true,
					// pin: true,
					markers: 0,
					// anticipatePin: 1,
					// pinSpacing: false,
				}
			});

			$('.collections__texte__group__visuels__visuel').each(function(i, el){
				var offset = $(window).height() * ( 0.1 + Math.random() * 0.5 );
				var offset = $(window).height() * $(el).data('speed');
				console.log('offset', offset);
				tl.fromTo( el, {
					y: offset
				}, {
					y: -offset,
					ease: 'none'
				}, 0)
			});
		});
	}, 500);
});

$(window).on('site:initPage', function(evt, el){
	if ( MQ(-768) ){
		return;
	}
	setTimeout(function() {
		$('.album__content').each(function(i, el){
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: $(el),
					start: "top bottom",
					end: () => "bottom top", // dynamique
					scrub: true,
					invalidateOnRefresh: true,
					// pin: true,
					markers: 0,
					// anticipatePin: 1,
					// pinSpacing: false,
				}
			});

			$(el).find('[data-speed]').each(function(i, el){
				// var offset = $(window).height() * ( 0.1 + Math.random() * 0.5 );
				var offset = $(window).height() * $(el).data('speed');
				console.log('offset', offset);
				tl.fromTo( el, {
					y: offset
				}, {
					y: -offset,
					ease: 'none'
				}, 0)
			});
		});
	}, 500);
});

$(window).on('site:initPage', function(evt, el){
	// if ( MQ(-768) ){
	// 	return;
	// }
	setTimeout(function() {
		$('[data-paralaxb-speed]').each(function(i, el){
			if ( $(el).attr('data-paralaxb-mq') == 'sm-up' ){
				if (MQ(-768)) {
					return;
				}
			}
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: $(el),
					start: "top bottom",
					end: () => "bottom top", // dynamique
					scrub: true,
					invalidateOnRefresh: true,
					// pin: true,
					markers: 0,
					// anticipatePin: 1,
					// pinSpacing: false,
				}
			});

			$(el).each(function(i, el){
				// var offset = $(window).height() * ( 0.1 + Math.random() * 0.5 );
				var offset = $(window).height() * $(el).data('paralaxb-speed');
				console.log('offset paralaxb-speed', offset);
				tl.fromTo( el, {
					y: offset
				}, {
					y: -offset,
					ease: 'none'
				}, 0)
			});
		});
	}, 500);
});

$(window).on('site:initPage', function(evt, el){
	$('.our__collections__en__savoir').on('click', function(){
		var $parent = MQ(768) ? $(this).closest('.our__collections__items') : $(this).closest('.our__collections__item');
		// var $parent = $(this).closest('.our__collections__item');
		$parent.toggleClass('is-active');
	});
});

$(window).on('site:initPage', function(evt, el){
	$(el).find('.presse__group__press__group__elements__titre:has(.presse__group__press__group__elements__visuel)').hover(function(){
		var src = $(this).find('img').attr('src');
		var $next = $('<div class="presse__group__infos__group__visuel__img" style="background-image:url('+src+');"></div>');
		var $previous = $('.presse__group__infos__group__visuel__img');
		$next.appendTo($('.presse__group__infos__group__visuel'));
		$next.get(0).offsetWidth;
		$next.addClass('is-active');
		$previous.removeClass('is-active');
		setTimeout(function() {
			$previous.remove();
		}, 300);
	}, function(){
		$('.presse__group__infos__group__visuel__img').removeClass('is-active');
	});
});



$(window).on('site:initPage', function(evt, el){
	$(el).find('.testimonials__bloc__testimonials__group__elements__item__header').click(function(){
		$('.testimonials__bloc__testimonials__group__elements__item').removeClass('is-active');
		$(this).closest('.testimonials__bloc__testimonials__group__elements__item').addClass('is-active');
	});
});


$(window).on('site:initPage', function(evt, el){
	var $movingImg = $('.testimonials__bloc__moving__img');

	// Centre l'élément initialement au milieu de l'écran
	gsap.set($movingImg, {
		// xPercent: -50,
		// yPercent: -50,
		x: window.innerWidth / 2,
		y: window.innerHeight / 2
	});

	$(el).find('.testimonials__bloc__testimonials__group__elements__texte:has(.testimonials__bloc__testimonials__group__elements__visuel)').hover(function(){
		var src = $(this).find('img').attr('src');
		var $next = $('<img class="testimonials__bloc__moving__img__item" src="'+src+'"/>');
		var $previous = $('.testimonials__bloc__moving__img__item');
		$next.appendTo($('.testimonials__bloc__moving__img__inner__inner'));
		$next.get(0).offsetWidth;
		$movingImg.addClass('is-active');
		$previous.removeClass('is-active');
		setTimeout(function() {
			$previous.remove();
		}, 300);

		// Quand on survole CET élément, on active le suivi de la souris
		$(this).on('mousemove.testimonialFollow', function(e) {
			gsap.to($movingImg, {
				x: e.clientX,
				y: e.clientY,
				duration: 0.5,
				ease: "power2.out",
				overwrite: "auto"
			});
		});

	}, function(){
		$movingImg.removeClass('is-active');
		
		// On coupe le mousemove spécifique à cet élément dès qu'on le quitte
		$(this).off('mousemove.testimonialFollow');
	});
});


$(window).on('site:initPage', function(evt, el){
	// if ( MQ(-768) ){
	// 	return;
	// }
	setTimeout(function() {
		$('.book__your__call__group__visuel').each(function(i, el){
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: $(el).parent(),
					start: "top bottom",
					end: () => "top top", // dynamique
					scrub: true,
					invalidateOnRefresh: true,
					// pin: true,
					markers: 0,
					// anticipatePin: 1,
					// pinSpacing: false,
				}
			});

			$(el).each(function(i, el){
				// var offset = $(window).height() * ( 0.1 + Math.random() * 0.5 );
				var offset = $(window).height() * $(el).data('speed');
				console.log('offset paralaxb-speed', offset);
				tl.fromTo( el, {
					y: offset
				}, {
					y: 0,
					ease: 'none'
				}, 0)
			});
		});
	}, 500);
});


$(window).on('site:initPage', function(evt, el) {
    handleFakeFormRedirection($(el));
    hydrateTargetEmailInput($(el));
});

function handleFakeFormRedirection($container) {
    var $fakeForm = $container.find('.footer__group__contact__group__texte');
    
    if ($fakeForm.length === 0) {
        return;
    }

    var $emailInput = $fakeForm.find('.footer__group__contact__group__texte__input');
    var $submitButton = $fakeForm.find('.footer__group__contact__group__texte__submit');

    var performSubmission = function() {
        var emailValue = $emailInput.val().trim();
        var targetUrl = $fakeForm.attr('data-url');

        if (emailValue === '') {
            return;
        }

        if (!targetUrl) {
            return;
        }

        sessionStorage.setItem('saved_user_email', emailValue);
        cymasmooth.goTo(targetUrl);
    };

    $submitButton.on('click', function(e) {
        e.preventDefault();
        performSubmission();
    });

    $emailInput.on('keydown', function(e) {
        if (e.key !== 'Enter') {
            return;
        }
        
        e.preventDefault();
        performSubmission();
    });
}

function hydrateTargetEmailInput($container) {
    var $targetEmailInput = $container.find('.wpcf7-form-control-wrap[data-name="email"] #email');
    
    if ($targetEmailInput.length === 0) {
        return;
    }

    var savedEmail = sessionStorage.getItem('saved_user_email');

    if (!savedEmail) {
        return;
    }

    $targetEmailInput.val(savedEmail);
    sessionStorage.removeItem('saved_user_email');
}  


$(window).on('site:initPage', function(evt, el){
    $(el).find('.home__video__group__video__preview__inner').each(function(i, currentItem){
        // Configuration
        const maxRotation = 0.5;
        const targetElement = currentItem;
        const easingFactor = 0.05; // Force du lissage (plus bas = plus lent/doux)

        // Valeurs cibles (Objectifs)
        let targetRotationY = 0;
        let targetScale = 1.1;

        // Valeurs actuelles (Positions réelles)
        let currentRotationY = 0;
        let currentScale = 1.1;

        // Événement mouvement de la souris
        window.addEventListener('mousemove', (event) => {
            const halfWidth = window.innerWidth / 2;
            const mouseXFromCenter = event.clientX - halfWidth;
            const ratioX = mouseXFromCenter / halfWidth;

            targetRotationY = ratioX * maxRotation;
            // targetScale = 1.2;
        });

        // Événement sortie de la souris
        window.addEventListener('mouseleave', () => {
            targetRotationY = 0;
            // targetScale = 1.1;
        });

        // Boucle d'animation (Render Loop)
        function updateAnimation(){
            // Formule de Lerp standard : current + (target - current) * easingFactor
            currentRotationY += (targetRotationY - currentRotationY) * easingFactor;
            currentScale += (targetScale - currentScale) * easingFactor;

            // Application directe via GSAP (sans tween interne) ou directement via inline style
            gsap.set(targetElement, {
                rotationY: currentRotationY,
                scale: currentScale
            });

            requestAnimationFrame(updateAnimation);
        }

        // Lancement de la boucle
        requestAnimationFrame(updateAnimation);
    });
});


$(window).on('site:initPage', function(evt, el){
    
    $('.documents__formulaire__item__line__button').on('click', function(e){
        e.preventDefault();

        var buttonElement = $(this);
        var sectionElement = $('.documents__section');
        var containerElement = buttonElement.closest('.documents__formulaire__item');
        
        var usernameInput = containerElement.find('input[name="identifiant"]').val();
        var passwordInput = containerElement.find('input[name="password"]').val();
        var postIdValue = containerElement.find('input[name="postid"]').val();
        var ajaxUrlTarget = containerElement.find('input[name="ajaxurl"]').val();

        sectionElement.addClass('form__loading');

        var startTime = new Date().getTime();

        $.ajax({
            url: ajaxUrlTarget,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'check_document_credentials',
                post_id: postIdValue,
                username: usernameInput,
                password: passwordInput
            },
            success: function(response){
                var endTime = new Date().getTime();
                var timeElapsed = endTime - startTime;
                var remainingTime = 500 - timeElapsed;

                if (remainingTime < 0) {
                    remainingTime = 0;
                }

                setTimeout(function(){
                    sectionElement.removeClass('form__loading');

                    if (response.success === true) {
                        sectionElement.addClass('form__success');
                        
                        if (response.data.download_url) {
                        	window.location.href = response.data.download_url;
                            // var downloadAnchor = document.createElement('a');
                            // downloadAnchor.href = response.data.download_url;
                            // downloadAnchor.setAttribute('download', '');
                            // downloadAnchor.setAttribute('target', '_blank');
                            // downloadAnchor.style.display = 'none';
                            // document.body.appendChild(downloadAnchor);
                            // downloadAnchor.click();
                            // document.body.removeChild(downloadAnchor);
                        }
                        
                        return;
                    }

                    var errorText = $('.documents__formulaire__group__identifiants__invalide').html();
                    
                    if ($.fancybox) {
                		$.fancybox.open('<div class="h3 popin is-alert">' + errorText + '</div>'); 
                        // $.fancybox.open('<div class="fancybox-error-message">' + errorText + '</div>');
                    }
                }, remainingTime);
            },
            error: function(){
                sectionElement.removeClass('form__loading');
            }
        });
    });

});

$(document).on('click', '[data-swiper-fancybox-index]', function (evt) {
    var currentEl = $(evt.currentTarget);
    evt.preventDefault();

    var targetGroup = currentEl.attr('data-swiper-fancybox-group');
    var targetIndex = parseInt(currentEl.attr('data-swiper-fancybox-index'), 10);

    // On cherche le swiper parent le plus proche pour isoler la recherche des slides
    var swiperContainer = currentEl.closest('.swiper-container');

    // On filtre pour ne prendre que les éléments dans les vrais slides (hors doublons Swiper)
    var realSlides = swiperContainer.find('.swiper-slide:not(.swiper-slide-duplicate) [data-swiper-fancybox-group="' + targetGroup + '"]');
    var galleryItems = [];

    realSlides.each(function () {
        var slideEl = $(this);
        var imgSrc = slideEl.attr('data-swiper-fancybox-src');

        if (!imgSrc) {
            return;
        }

        var item = {
            src: imgSrc
        };
        var imgCaption = slideEl.attr('data-swiper-fancybox-caption');

        if (imgCaption) {
            item.opts = {
                caption: imgCaption
            };
        }

        galleryItems.push(item);
    });

    if (galleryItems.length === 0) {
        return;
    }

    // Ouverture de FancyBox v3 avec la liste propre et l'index récupéré
    $.fancybox.open(galleryItems, {
        // Options globales de FancyBox v3
    }, targetIndex);
});

$(window).on('site:initPageo', function(evt, el){
	// if ( MQ(-768) ){
	// 	return;
	// }
	ScrollTrigger.config({ ignoreMobileResize: true })
	setTimeout(function() {
		const triggerElement = document.querySelector('.home__intro__group__visuel__wrap__wrap');
		    const targetElement = document.querySelector('.home__intro__group__visuel__wrap');

		    if (!triggerElement) {
		        return;
		    }

		    if (!targetElement) {
		        return;
		    }

		    // Uniquement sur mobile / petits écrans
		    const mobileQuery = window.matchMedia('(max-width: 767px)');

		    if (!mobileQuery.matches) {
		        return;
		    }

		    const calculateDistance = function() {
		        const totalWidth = targetElement.getBoundingClientRect().width;
		        const viewportWidth = window.innerWidth;
		        const remainingDistance = totalWidth - viewportWidth;

		        if (remainingDistance <= 0) {
		            return 0;
		        }

		        return -remainingDistance;
		    };

		    gsap.to(targetElement, {
		        x: function() {
		            return calculateDistance();
		        },
		        ease: 'none',
		        scrollTrigger: {
		            trigger: triggerElement,
		            start: 'top top',
		            end: 'bottom bottom',
		            scrub: true,
		            invalidateOnRefresh: true
		        }
		    });
	}, 500);
});



$(window).on('site:initPage', function(evt, el){
	if ($('.home__intro__group.v2').length) {
		return;
	}
	const wrap = document.querySelector('.home__intro__group__visuel__wrap');
    const track = document.querySelector('.custom-scrollbar__track');
    const thumb = document.querySelector('.custom-scrollbar__thumb');

    if (!wrap || !track || !thumb) {
        return;
    }

    const mobileQuery = window.matchMedia('(max-width: 767px)');
    if (!mobileQuery.matches) {
        return;
    }

    // Calcul des limites
    const maxVisualScroll = wrap.getBoundingClientRect().width - window.innerWidth;
    const maxThumbScroll = track.getBoundingClientRect().width - thumb.getBoundingClientRect().width;

    if (maxVisualScroll <= 0 || maxThumbScroll <= 0) {
        return;
    }

    // Ratio de conversion entre la poignée et le visuel
    const ratio = maxVisualScroll / maxThumbScroll;

    // Poignée draggables avec GSAP Draggable
    Draggable.create(thumb, {
        type: 'x',
        bounds: track,
        inertia: true,
        edgeResistance: 0.85,
        onDrag: function() {
            updateVisualPosition(this.x);
        },
        onThrowUpdate: function() {
            updateVisualPosition(this.x);
        }
    });

    function updateVisualPosition(thumbX) {
        const targetX = -thumbX * ratio;

        gsap.to(wrap, {
            x: targetX,
            duration: 0.2,
            ease: 'power1.out',
            overwrite: 'auto'
        });
    }
});

$(window).on('site:initPage', function(evt, el){
	if (MQ(-768)) {
		return;
	}
	return;
    $('.home__chiffres__group__visuel').each(function(i, el){
        function getH() {
            return $(window).height() - $('.home__chiffres__group__visuel__spacer').height();
        }

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: $(el),
                start: "top bottom",
                end: () => '+=' + getH(),
                scrub: true,
                invalidateOnRefresh: true,
                // pin: true,
                markers: 0,
                // anticipatePin: 1,
                // pinSpacing: false,
            }
        });

        $(el).find('.home__chiffres__group__visuel__inner').each(function(i, el){
            tl.fromTo( el, {
                y: () => -getH() * 0.5
            }, {
                y: 0,
                ease: 'none'
            }, 0)
        });
    });
});

$(window).on('loading-done', function(){
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	
	if (MQ(768)) {
		
		tl.set( $('.home__intro__group__lettres__item'), {
			opacity: 1,
			stagger: 0.2,
		}, 0 );
		tl.fadeUp( $('.home__intro__group__lettres__lettre'), {
			yOrigin: -50,
			stagger: 0.2,
		}, 0 );
		tl.fadeUp( $('.home__intro__group__lettres__texte__2'), {
			yOrigin: -50,
			stagger: 0.2,
		}, 0.2 );
		tl.fadeUp( $('.home__intro__group__lettres__texte__1, .home__intro__group__lettres__date'), {
			yOrigin: 0,
			stagger: 0
		}, 1.2 );
	}
	else {
		
		// tl.fromTo( $('.home__intro__group__lettres__lines line'), {
		// 	drawSVG:'100% 100%'
		// }, {
		// 	drawSVG:'0% 100%',
		// 	duration: 1
		// }, 0 )
		// tl.to( $('.home__intro__group__lettres__lines line'), {
		// 	opacity: 1,
		// 	stagger: 0.1,
		// 	ease: 'none',
		// 	duration: 1,
		// }, 0 )
	}
	
	setTimeout(function() {
		tl.play();
	}, 5);
});

